import layout from '@/layout/index.vue'
export default {
  name: 'group-spm-desk-open',
  meta: { title: '开台记录', icon: 'icon-order' },

  children: [
    {
      name: 'spm-desk-open',
      meta: { title: '今日开台', icon: 'el-icon-monitor' },

      routers: [
        {
          path: '/today-desk-open',
          name: 'today-desk-open',
          component: layout,
          meta: { title: '今日开台' },
          children: [
            {
              path: 'index',
              name: 'index',
              component: () => import('@/views/desk-open/today-desk-open/index.vue'),
              meta: {
                title: '今日开台',
                vPermission: ['pc-bar-desk-open:today-desk-open:index']
              }
            }
          ]
        }
      ]
    }
  ]
}
